let LOCALES: { [key: string]: string } = {};

export const setLocales = (locales: { [key: string]: string }) => LOCALES = locales;

export const getLocales = () => LOCALES;